export const countUp = (trigger, counter) => {
  const number = Number(counter.dataset.number)
  let current = 0

  const count = (increasement = 1) => {
    if (current <= number) {
      current = Math.min(number, current + increasement)
    }

    counter.textContent = current.toLocaleString('en-US')
  }

  const observer = new IntersectionObserver((el) => {
    if (el[0].isIntersecting) {
      const interval = setInterval(() => {
        if (current < number) {
          count(Math.max(1, Math.ceil(number / 100)))
        } else {
          clearInterval(interval)
        }
      }, 20)
    }
  }, { threshold: [0] })

  observer.observe(trigger)
}

const init = (wrapper) => {
  wrapper.querySelectorAll('.js-stats-item').forEach((item) => {
    countUp(item, item.querySelector('.js-stats-item-number'))
  })
}

export default () => {
  document.querySelectorAll('.js-stats').forEach((wrapper) => {
    if (!wrapper.classList.contains('is-initialized')) {
      wrapper.classList.add('is-initialized')
      init(wrapper)
    }
  })
}
